export const CACHE_KEY_TOKEN = ['token'];
export const CACHE_KEY_USER = ['user'];
export const CACHE_KEY_COMPANY = ['company'];
export const CACHE_KEY_ABSENCES = ['absences'];